import React, {Component, useState} from 'react';
import Logo from "./Logo";
import {Box, Button, CssBaseline} from "@mui/material";
import Planet from "../assets/planet.svg";
import Boxs from "../assets/box.svg";

let count = 0;
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        count++;
        console.error('Error caught by Error Boundary:', error, errorInfo);
        this.setState({ hasError: true, details: error?.message + errorInfo?.componentStack });
    }

    resetErrorBoundary() {
        this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return (
                <SomethingWentWrong resetErrorBoundary={this.resetErrorBoundary} details={this.state.details} />
            );
        }

        return this.props.children;
    }
}

const SomethingWentWrong = ({resetErrorBoundary, details}) => {
    const [showDetails, setShowDetails] = useState(false);
    return (
        <>
            <CssBaseline/>
            <Logo items={0} goHome={resetErrorBoundary} total={0} />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height={'100%'}
                className={"Loading"}
                sx={{userSelect: 'none', overflow: 'hidden', position: "absolute", top: 0, width: "100%", flexDirection:"column"}}
            >
                <div style={{position: "relative", display:"flex", flexDirection: "column", justifyContent:"center", alignItems: "center"}}>
                    <img src={Planet} id={'logo-spin'}
                         alt={'logo'} style={{position: "absolute",  filter: "grayscale(100%)", top: 64,
                        animation: "App-logo-spin linear 60s infinite reverse",
                        animationPlayState:'running',
                    }}/>
                    <img src={Boxs} id={'logo-spin'}
                         alt={'logo'} style={{position: "relative", filter: "grayscale(100%)"
                    }}/>
                </div>
                <h1 style={{marginTop: "1.5em", padding: "0 1em", textAlign: "center"}}>Something went wrong{count > 1 ? `... ${count} times` : ""} :(</h1>
                <div style={{display:"flex", gap: 8}}>
                <Button sx={{pointerEvents: 'all'}} onClick={resetErrorBoundary}>Retry</Button>
                <Button sx={{pointerEvents: 'all'}} disabled={showDetails} onClick={()=>setShowDetails(true)}>Details</Button>
                </div>
                {showDetails && <span style={{padding: "1em", maxWidth: "500px"}}>{details}</span>}
            </Box>
        </>
    )
}

export default ErrorBoundary;